import { combineReducers } from "redux";

// REDUCERS
import { heroReducer } from "./heroReducer";
import { logsReducer } from "./logsReducer";
import { monstersReducer } from "./monstersReducer";
import gameDataReducer from "./gameDataReducer";
import animateReducer from "./animateReducer";
import { userReducer } from "./userReducer";
import characterReducer from "./characterReducer";
import { questsReducer } from "./questsReducer";

export default combineReducers({
    hero: heroReducer,
    monsters: monstersReducer,
    logs: logsReducer,
    gameData: gameDataReducer,
    animate: animateReducer,
    user: userReducer,
    character: characterReducer,
    quests: questsReducer,
})